<div class="portal-gallary">
    <gallery *ngIf="images.length > 1" [items]="images" [id]="id" imageSize="cover" thumbView="contain" [counter]="false"></gallery>
    <gallery *ngIf="images.length <= 1" [items]="images" [id]="id" imageSize="cover" thumbView="contain" [thumb]="false"></gallery>
</div>

